<template>
    <main
        id="page-my-account"
        class="bg-gray-100"
    >
        <div class="container mx-auto">
            <Breadcrumb/>
        </div>
        <section class="container mx-auto pb-16 space-y-4 lg:grid lg:grid-cols-2 lg:gap-16 lg:space-y-0 lg:pt-16">
            <div class="col-span-2">
                <h1 class="text-2xl lg:text-5xl">
                    Anmelden
                </h1>
            </div>
            <div class="panel text-sm lg:text-base">
                <div class="p-8 space-y-8">
                    <h2 class="h3">
                        Konto eröffnen
                    </h2>
                    <p>
                        Wenn Sie sich bei unserem Konto anmelden haben Sie den Vorteil, dass Ihr persönlicher Merkzettel
                        auch beim Verlassen unserer Homepage gespeichert wird und Ihnen beim nächsten Besuch zur
                        Verfügung seht.
                    </p>
                    <p>Natürlich können Sie jederzeit alle Inhalte des Merkzettels löschen.</p>
                    <UButton
                        :to="{name: 'registration'}"
                        label="Konto eröffnen"
                    />
                </div>
            </div>

            <div class="panel text-sm lg:text-base">
                <div class="p-8 space-y-8">
                    <h2 class="h3">
                        Anmelden
                    </h2>
                    <p>
                        Falls Sie schon Kunde bei uns sind, melden Sie sich bitte hier mit Ihrer E-Mail-Adresse und
                        Ihrem Passwort an.
                    </p>
                    <form @submit.prevent="login">
                        <UInput
                            v-model="credentials.email"
                            trailing-icon="i-lucide-at-sign"
                            placeholder="E-Mail"
                            size="lg"
                            class="w-full"
                        />
                        <UInput
                            v-model="credentials.password"
                            placeholder="Passwort"
                            :type="showPassword ? 'text' : 'password'"
                            :ui="{ trailing: 'pe-1' }"
                            size="lg"
                            class="w-full"
                        >
                            <template #trailing>
                                <UButton
                                    color="neutral"
                                    variant="link"
                                    size="sm"
                                    :icon="showPassword ? 'i-lucide-eye-off' : 'i-lucide-eye'"
                                    :aria-label="showPassword ? 'Hide password' : 'Show password'"
                                    :aria-pressed="showPassword"
                                    aria-controls="password"
                                    @click="showPassword = !showPassword"
                                />
                            </template>
                        </UInput>
                        <div>
                            <div>
                                <div
                                    v-if="error"
                                    class="text-secondary mb-4"
                                >
                                    {{ error }}
                                </div>
                                <UButton
                                    :disabled="loggingIn"
                                    @click="login"
                                >
                                    Anmelden
                                </UButton>
                            </div>
                        </div>
                    </form>
                    <div>
                        <div>&nbsp;</div>
                        <div>
                            <NuxtLink
                                :to="{name: 'forgot-password'}"
                                class="text-secondary underline"
                            >
                                Passwort vergessen?
                            </NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script setup lang="ts">
import {useWishlistStore} from '~~/stores/wishlist';

definePageMeta({
    auth: false,
    path: '/anmelden',
});

const router = useRouter();
const {
    signIn,
    getSession,
} = useAuth(); // sidebase
const showPassword = ref(false);
const credentials = reactive({
    email: '',
    password: '',
});
const loggingIn = ref(false);
const error = ref<string | false>(false);
const store = useWishlistStore();

async function login(e: Event) {
    e.preventDefault();
    loggingIn.value = true;
    error.value = '';

    try {
        await signIn({
            username: credentials.email,
            password: credentials.password,
        }, {redirect: false});
        error.value = false;
        const session: any = await getSession();
        await store.login(session);
        await router.push({name: 'wishlist'});
    } catch (err: any) {
        console.error(err);
        error.value = 'Login fehlgeschlagen';
    } finally {
        loggingIn.value = false;
    }
}
</script>
